import { usePromptOptimizationJobWithLogs } from '@/hooks/useSwr';

import { JobDetails } from './JobDetails';
import { Logs } from './Logs';
import { MetricsOverTimeChart } from './MetricsOverTimeChart';
import { COMPLETED_STATUSES } from './constants';

export const OptimizationRun = ({
  repoName,
  jobId,
}: {
  repoName: string;
  jobId: string;
}) => {
  const { data: job } = usePromptOptimizationJobWithLogs(repoName, jobId, {
    revalidateOnFocus: true,
    refreshInterval: 2000,
  });

  const isJobCompleted = !!(
    job?.status && COMPLETED_STATUSES.includes(job.status)
  );

  return (
    <div className="flex flex-col gap-8 px-2 pt-1">
      <JobDetails job={job} />
      <MetricsOverTimeChart results={job?.results ?? []} />
      <Logs logs={job?.logs} isCompleted={isJobCompleted} />
    </div>
  );
};
